import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscClueIndustryKeyword',

    selectById(query){
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: query
        });
    },

    updateById(query){
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: query
        });
    },

    deleteById(query){
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: query
        });
    },

    selectPage(query){
        return http({
            url: this.baseurl + '/selectPage',
            method: 'get',
            params: query
        });
    },


    insert(query){
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: query
        });
    },





}
